<template>
  <div class="studentIndex">
    <audio id="audio" ref="audio" src="../../../public/sound/clickSound.wav" type="audio/wav" style="width: 0;height: 0;position: absolute;top: 0;"></audio>
    <audio id="audioNoclick" ref="audioNoclick" src="../../../public/sound/noclick.mp3" type="audio/mp3" style="width: 0;height: 0;position: absolute;top: 0;"></audio>
    <router-view @clickAudio="clickAudio" @clickNoAudio="clickNoAudio"></router-view>
    <div class="mask_box" ref="maskBox"></div>
  </div>
</template>

<script>
import { isHaveTrain, getPmzt, getTrainingUsTime, myPersonalConfig } from '@/api/student'
// import { loginOut } from '@/api/login'
export default {
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    clickAudio() {
      this.$refs.audio.play()
    },
    clickNoAudio() {
      this.$refs.audioNoclick.play()
    },
  },
  mounted(){
    // 个人资料里面护眼模式打开，sessionStorage里面eye是字符串true，关闭是字符串false
    myPersonalConfig({xsid: this.$store.state.userInfo.yhid}).then(res => {
      if(!res.result) {
        return
      }
      this.$refs.maskBox.style = res.result.hyms ? 'background:rgba(237, 251, 239, .3);' : ''
    })
    this.$Bus.$on('eye', val => {
      console.log(val)
      this.$refs.maskBox.style = sessionStorage.getItem('eye') == 'true' ? 'background:rgba(237, 251, 239, .3);' : ''
    })

    isHaveTrain({ yhid: this.$store.state.userInfo.yhid, yycdid: sessionStorage.getItem('yycdid')  }).then(res => {
      if (res.success) {
        if (res.result.jxid) {
          // 登录时判断当前屏幕状态, 0锁屏,1正常访问
          getPmzt({
            bjid: res.result.bjid
          }).then(a => {
            // 判断该班级集训是否已结束，jxzt为0已结束，1 未结束
            getTrainingUsTime({ bjid: res.result.bjid }).then(e => {
              if (e.success) {
                if (!e.result.jxzt) {
                  this.jxzt = true
                } else {
                  this.jxzt = false
                }
              }
            })
          })
        }
      }
    })
    // 禁止复制粘贴
    this.$nextTick(() => {
      if(document.body.offsetWidth < 1300){
        document.onselectstart = new Function("event.returnValue=false");
      }
    })
    // 禁止浏览器前进后退
    window.history.forward(-1)
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.forward(-1)
      history.pushState(null, null, document.URL);
    })
  },

}
</script>
<style lang="scss" scoped>
.mask_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 5002;
}
</style>

<style lang="scss">
.el-message-box__status+.el-message-box__message{
  padding: 0 !important;
  margin-left: 0 !important;
}
@media screen and (max-width: 1366px) {
  .el-message-box--center .el-message-box__header {
    padding-top: 0 !important;
  }
}
.el-message--success,
.el-message--error,
.el-message--warning {
  background-color: rgba(185, 208, 255, 1) !important;
  border-color: #fff !important;
  box-shadow: 0 2px 9px 2px rgba(22, 54, 118, 0.2) !important;
  opacity: 0.9 !important;
  height: 58px;
  z-index: 3001;
}

.el-message--success .el-message__content,
.el-message--error .el-message__content,
.el-message--warning .el-message__content {
  font-size: 24px !important;
  color: #333 !important;
  padding-left: 20px;
}

.el-message .el-icon-success {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("../../assets/images/student/yes.png") no-repeat;
  background-size: 100% 100%;
}

.el-message .el-icon-error {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("../../assets/images/student/no.png") no-repeat;
  background-size: 100% 100%;
}

.el-message .el-icon-warning {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("../../assets/images/student/sigh.png") no-repeat;
  background-size: 100% 100%;
}

.el-icon-success:before,
.el-icon-error:before,
.el-icon-warning:before {
  display: none;
}

.el-message-box {
  border-radius: 10px;
  width: 25vw !important;
  border: none;
  overflow: visible;
  border-radius: 15px;
}

.el-message-box__header {
  width: 100%;
  height: 3vw;
  background: #5990FF;
  border-radius: 10px 10px 0 0;
  border: 2px solid #5990FF;
  text-align: center;
  line-height: 2.5vw;
  padding-bottom: 26px;
}

.el-message-box__title {
  height: 100%;
  font-size: 1.3vw;
  color: #fff;
}

.el-message-box__headerbtn {
  display: none;
}

.el-message-box__content {
  position: relative;
  padding: 1.5vw 1vw;
}

.el-message-box__container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.el-message-box__message {
  position: relative;
}

.el-message-box__message p {
  font-size: 1.0vw;
  line-height: 1.3;
  color: red;
  text-align: center;
  width: auto !important;
}

.el-message-box__status.el-icon-warning {
  background: url("../../assets/images/student/sigh.png") no-repeat;
  width: 2vw;
  height: 2vw;
  background-size: 100% 100%;
  position: static;
  left: auto;
  top: auto;
  flex-shrink: 0;
  margin-right: 0.8vw;
}

.el-message-box__btns {
  text-align: center;
  padding-bottom: 10px;
}

.el-button--small,
.el-button--small.is-round {
  padding: 1vh 2vw !important;
  font-size: 1.2vw;
  border-radius: 30px;
}


/* ========== 平板横屏 & 小屏笔记本 (1024px - 1366px) ========== */
@media screen and (max-width: 1366px) and (min-width: 1024px) {
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 52px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 20px !important;
    padding-left: 16px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 26px;
    height: 26px;
  }

  .el-message-box {
    width: 35vw !important;
  }

  .el-message-box__header {
    height: 45px;
    line-height: 45px;
    padding-bottom: 0;
  }

  .el-message-box__title {
    font-size: 18px;
  }

  .el-message-box__content {
    height: auto;
    padding: 18px;
  }

  .el-message-box__message {
    height: auto;
    padding: 0 !important;
  }

  .el-message-box__message p {
    font-size: 14px;
    position: static;
    transform: none;
    text-align: center;
  }

  .el-message-box__status.el-icon-warning {
    width: 28px;
    height: 28px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 8px 18px !important;
    font-size: 13px;
  }
}

/* ========== 平板竖屏 (755px - 1024px) - 优化边界 ========== */
@media screen and (max-width: 1024px) and (min-width: 755px) {
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 48px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 16px !important;
    padding-left: 12px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 24px;
    height: 24px;
  }

  .el-message-box {
    width: 50vw !important;
    max-width: 450px;
  }

  .el-message-box__header {
    height: 44px;
    line-height: 44px;
    padding-bottom: 0;
  }

  .el-message-box__title {
    font-size: 16px;
  }

  .el-message-box__content {
    padding: 16px;
  }

  .el-message-box__message p {
    font-size: 14px;
    position: static;
    transform: none;
    text-align: center;
  }

  .el-message-box__status.el-icon-warning {
    width: 26px;
    height: 26px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 8px 20px !important;
    font-size: 13px;
  }
}

/* ========== 手机横屏到平板过渡 (481px - 767px) - 补充适配 ========== */
@media screen and (min-width: 481px) and (max-width: 767px) {
  /* 消息提示适配 */
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 46px;
    min-width: 200px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 15px !important;
    padding-left: 12px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 23px;
    height: 23px;
  }

  /* 弹窗适配 */
  .el-message-box {
    width: 70vw !important;
    max-width: 400px;
  }

  .el-message-box__header {
    height: 44px;
    line-height: 44px;
    padding-bottom: 0;
  }

  .el-message-box__title {
    font-size: 16px;
  }

  .el-message-box__content {
    padding: 16px;
  }

  .el-message-box__message {
    height: auto;
    padding: 0 !important;
  }

  .el-message-box__message p {
    font-size: 13px;
    position: static;
    transform: none;
    text-align: center;
    line-height: 1.4;
  }

  .el-message-box__status.el-icon-warning {
    width: 26px;
    height: 26px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 7px 18px !important;
    font-size: 12px;
  }

  .el-message-box__status + .el-message-box__message {
    padding: 0 !important;
  }
}

/* ========== 手机横屏 (480px - 768px) - 优化原有样式 ========== */
@media screen and (max-width: 768px) and (min-width: 480px) {
  /* 移除 orientation 限制，让横屏竖屏都适用 */
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 46px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 14px !important;
    padding-left: 10px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 22px;
    height: 22px;
  }

  .el-message-box {
    width: 70vw !important;
    max-width: 380px;
  }

  .el-message-box__header {
    height: 42px;
    line-height: 42px;
    padding-bottom: 0;
  }

  .el-message-box__title {
    font-size: 15px;
  }

  .el-message-box__content {
    padding: 14px;
  }

  .el-message-box__message p {
    font-size: 13px;
    position: static;
    transform: none;
    text-align: center;
  }

  .el-message-box__status.el-icon-warning {
    width: 24px;
    height: 24px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 6px 16px !important;
    font-size: 12px;
  }
}

/* ========== 手机竖屏 (320px - 480px) ========== */
@media screen and (max-width: 480px) and (orientation: portrait) {
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 40px;
    min-width: 180px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 12px !important;
    padding-left: 8px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 20px;
    height: 20px;
  }

  .el-message-box {
    width: 78vw !important;
  }

  .el-message-box__header {
    height: 40px;
    line-height: 40px;
    padding-bottom: 0;
  }

  .el-message-box__title {
    font-size: 14px;
  }

  .el-message-box__content {
    padding: 15px;
  }

  .el-message-box__message p {
    font-size: 12px;
  }

  .el-message-box__status.el-icon-warning {
    width: 22px;
    height: 22px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 5px 14px !important;
    font-size: 12px;
  }
}

/* ========== 小屏手机 (≤ 375px) ========== */
@media screen and (max-width: 375px) {
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 36px;
    min-width: 160px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 11px !important;
    padding-left: 6px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 18px;
    height: 18px;
  }

  .el-message-box {
    width: 74vw !important;
  }

  .el-message-box__header {
    height: 38px;
    line-height: 38px;
  }

  .el-message-box__title {
    font-size: 13px;
  }

  .el-message-box__content {
    padding: 12px;
  }

  .el-message-box__message p {
    font-size: 11px;
  }

  .el-message-box__status.el-icon-warning {
    width: 20px;
    height: 20px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 6px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 4px 12px !important;
    font-size: 11px;
  }
}

/* ========== 超小屏手机 (≤ 320px) ========== */
@media screen and (max-width: 320px) {
  .el-message--success,
  .el-message--error,
  .el-message--warning {
    height: 32px;
    min-width: 140px;
  }

  .el-message--success .el-message__content,
  .el-message--error .el-message__content,
  .el-message--warning .el-message__content {
    font-size: 10px !important;
    padding-left: 5px;
  }

  .el-message .el-icon-success,
  .el-message .el-icon-error,
  .el-message .el-icon-warning {
    width: 16px;
    height: 16px;
  }

  .el-message-box__header {
    height: 35px;
    line-height: 35px;
  }

  .el-message-box__title {
    font-size: 12px;
  }

  .el-message-box__message p {
    font-size: 10px;
  }

  .el-message-box__status.el-icon-warning {
    width: 18px;
    height: 18px;
    position: static;
    left: auto;
    top: auto;
    flex-shrink: 0;
    margin-right: 6px;
  }

  .el-button--small,
  .el-button--small.is-round {
    padding: 3px 10px !important;
    font-size: 10px;
  }
}
</style>



